import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { jwtDecode } from 'jwt-decode';

import { UtilitarioService } from '../../service/utilitarios/utilitario.service';
import { MaeUsuarioService } from '../../service/mae-usuario.service';
import { ResponseMensaje,MensajeServicioAD,MensajeServicioUtil } from '../../model/response-dml';
import { AdminCredential, AdminCredentialUtil } from '../../model/request_credenciales';

@Component({
  selector: 'app-login-admin',
  templateUrl: './login-admin.component.html',
  styleUrls: ['./login-admin.component.scss']
})
export class LoginAdminComponent implements OnInit {

  constructor(
    private utilitarioService:UtilitarioService,
    private maeUsuarioService:MaeUsuarioService,
    private router : Router,
    ) { }

    txtLoginAdmin:String = "";
    txtPasswordAdmin:String = "";

    valFormLogin: FormGroup;
    version:string='-';

  get txtUsuario() {return this.valFormLogin.get('txtUsuarioVal');}
  get txtclave() {return this.valFormLogin.get('txtClaveVal');}

  ngOnInit(): void {

    this.valFormLogin = new FormGroup({
      txtUsuarioVal: new FormControl('', Validators.required),
      txtClaveVal: new FormControl('', Validators.required)

    });

    try{
      this.maeUsuarioService.getVersion().subscribe(data=>{
        console.log(data);
        if(data != null)
          this.version = 'Version '+data.version;
        else
          this.version = 'No Version en BD';
      });
    }
    catch{
      this.version = "Api error"
    }
  }

  // async onIngresar(){

  //   if (this.valFormLogin.valid){

  //     let adminCredential = new AdminCredentialUtil();
  //     adminCredential.idSistema = 13;
  //     adminCredential.usuarioDominio = this.txtUsuario.value;
  //     adminCredential.contrasena = this.txtclave.value;

  //     this.utilitarioService.loading=true;
  //     var responseUser: MensajeServicioUtil;
  //     var consultarDominio : boolean = true;
  //     //let responseUser: any;
  //     try{
  //       responseUser = await this.maeUsuarioService.getLoginUtil(adminCredential).toPromise();
  //       console.log(responseUser);
  //     }
  //     catch{
  //       this.utilitarioService.toastrError("No se puede conectar con el servicio de autentificacion de Usuario de Dominio.");
  //       consultarDominio=false
  //       this.utilitarioService.loading=false;
  //     }

  //     if (consultarDominio)
  //     if(responseUser.codigo == "000" && responseUser.token)
  //     {
  //       // try {
  //       // const decodedToken: any = jwt_decode(responseUser.token);
  //       // console.log("Token decodificado:", decodedToken);

  //       // // Puedes validar fechas, claims, etc. aquí
  //       // const now = Math.floor(Date.now() / 1000);
  //       // if (decodedToken.exp < now) {
  //       //   throw new Error("Token expirado.");
  //       // }

  //       // localStorage.setItem("auth_token", responseUser.token); // Guarda token

  //       // Solo después de validado el token, ejecutas getUser()
  //         this.maeUsuarioService.getUser(adminCredential.usuarioDominio,"0").subscribe(data=>{
  //           console.log(data);
  //           if (data.length>0){

  //               if(data[0].c_estado==3) //cod de mae_tabla  para ACTIVO
  //               {

  //               localStorage.setItem("c_usuario", data[0].c_usuario.toString());
  //               localStorage.setItem("c_usuario_firma", data[0].c_usuario.toString());
  //               localStorage.setItem("x_usuario", data[0].x_usuario.toString());
  //               localStorage.setItem("c_perfil", data[0].c_perfil.toString());
  //               localStorage.setItem("x_nombres", data[0].x_nombres + ' ' + data[0].x_ape_pat + ' ' + data[0].x_ape_mat);

  //               this.utilitarioService.loading=false;

  //               this.utilitarioService.toastrSuccess("Bienvenido(a) " + data[0].x_nombres);
  //               this.router.navigate(['/dashboard/inicio']);
  //               /*
  //               if (this.globalVariablesService.getC_perfil()=="1"){
  //                 this.router.navigate(['/dashboard/inicio/a']);
  //               }else{
  //                 this.router.navigate(['/dashboard/gestionconstanciafirma/a']);
  //               }*/

  //             }else{
  //               this.utilitarioService.toastrError("El usuario se encuentra de baja");
  //             }

  //           }else{
  //             this.utilitarioService.toastrError("El usuario no se encuentra registrado.");
  //           }
  //           this.utilitarioService.loading=false;
  //         },
  //         error => {
  //           this.utilitarioService.toastrError("No se puede conectar con el servicio.");
  //           this.utilitarioService.loading=false;
  //           console.log(error);
  //         });

  //       }
  //     else{
  //       this.utilitarioService.toastrError(responseUser.mensaje);
  //       console.log(responseUser);
  //       this.utilitarioService.loading=false;
  //     }

  //   }else{
  //     this.valFormLogin.markAllAsTouched();
  //   }

  // }


  async onIngresar() {
  if (this.valFormLogin.valid) {
    let adminCredential = new AdminCredentialUtil();
    adminCredential.idSistema = 13;
    adminCredential.usuarioDominio = this.txtUsuario.value;
    adminCredential.contrasena = this.txtclave.value;

    this.utilitarioService.loading = true;
    let responseUser: any;

    try {
      responseUser = await this.maeUsuarioService.getLoginUtil(adminCredential).toPromise();
      console.log("Respuesta login:", responseUser);
    } catch (error) {
      this.utilitarioService.toastrError("No se puede conectar con el servicio de autenticación.");
      this.utilitarioService.loading = false;
      return;
    }

    // ✅ Validar token
    if (responseUser.codigo === "000" && responseUser.token) {
      try {
        const decodedToken: any = jwtDecode(responseUser.token);
        console.log("Token decodificado:", decodedToken);

        // Puedes validar fechas, claims, etc. aquí
        const now = Math.floor(Date.now() / 1000);
        if (decodedToken.exp < now) {
          throw new Error("Token expirado.");
        }

        localStorage.setItem("auth_token", responseUser.token); // Guarda token

        // Solo después de validado el token, ejecutas getUser()
        this.maeUsuarioService.getUser(adminCredential.usuarioDominio, "0").subscribe(data => {
          console.log("Datos usuario:", data);
          if (data.length > 0 && data[0].c_estado == 3) {

            localStorage.setItem("c_usuario", data[0].c_usuario.toString());
            localStorage.setItem("c_usuario_firma", data[0].c_usuario.toString());
            localStorage.setItem("x_usuario", data[0].x_usuario.toString());
            localStorage.setItem("c_perfil", data[0].c_perfil.toString());
            localStorage.setItem("x_nombres", `${data[0].x_nombres} ${data[0].x_ape_pat} ${data[0].x_ape_mat}`);

            this.utilitarioService.toastrSuccess("Bienvenido(a) " + data[0].x_nombres);
            this.router.navigate(['/dashboard/inicio']);
          } else {
            this.utilitarioService.toastrError("El usuario no se encuentra activo o no existe.");
          }

          this.utilitarioService.loading = false;
        }, error => {
          this.utilitarioService.toastrError("Error al consultar el usuario.");
          this.utilitarioService.loading = false;
        });

      } catch (tokenError) {
        console.error("Token inválido:", tokenError);
        this.utilitarioService.toastrError("Token inválido o expirado.");
        this.utilitarioService.loading = false;
      }

    } else {
      this.utilitarioService.toastrError(responseUser.mensaje || "Credenciales incorrectas.");
      this.utilitarioService.loading = false;
    }

  } else {
    this.valFormLogin.markAllAsTouched();
  }
}
}
